import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './components/login/login.component';
import { DirectLinkLoginComponent } from './components/direct-link-login/direct-link-login.component';

@NgModule({
  declarations: [LoginComponent, DirectLinkLoginComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class LoginModule { }
